export const pagoPremioConstants = {
  LIST_PREMIO_REQUEST: 'LIST_PREMIO_REQUEST',
  LIST_PREMIO_SUCCESS: 'LIST_PREMIO_SUCCESS',
  LIST_PREMIO_FAILURE: 'LIST_PREMIO_FAILURE'
};
